import { Component } from "react";
import "./PasswordResetDone.css";
import PageFormWithHeader from "../../components/page/PageForm/PageFormWithHeader";
import AuthRedirect from "../../components/auth/components/AuthRedirect/AuthRedirect";
import Button from "../../components/formElements/Button/Button";

export default class PasswordResetDone extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.redirect = this.redirect.bind(this);
  }

  redirect() {
    this.setState({ redirect: true });
  }

  render() {
    const action = (
      <div>
        <Button className="btn" onClick={this.redirect}>
          Sign In
        </Button>
      </div>
    );

    return (
      <AuthRedirect redirectToReferrer={this.state.redirect}>
        <PageFormWithHeader
          className="reset-done"
          formClassName="resetdone-form"
          title="Your password has been reset"
          formActions={action}
          withLogo={this.props.withLogo}
        >
          <div>
            <p>
              Your Talaera password has been reset. To continue, please sign in with your
              new password now.
            </p>
          </div>
        </PageFormWithHeader>
      </AuthRedirect>
    );
  }
}
